import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import Raven from 'raven-js';
import RetakePracticalExerciseModal from './RetakePracticalExerciseModal';
import UsageTracker from '../../../utils/UsageTracker';
import { useDeletePracticalExerciseProgress } from '../practicalExerciseQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseRetryButtonContainer = ({
  contentId,
  lessonId,
  requiredAccess,
  requiredProduct,
  trackId,
  use = 'secondary'
}) => {
  const [displayRetakeModal, setDisplayRetakeModal] = useState(false);
  const [deletePracticalExerciseProgress] = useDeletePracticalExerciseProgress();
  const handleClickRetakeExercise = () => setDisplayRetakeModal(true);
  const handleRejectRetakePracticalExercise = () => setDisplayRetakeModal(false);
  const handleOnRetryPracticalExercise = id => {
    deletePracticalExerciseProgress({
      contentId: id,
      lessonId,
      trackId
    }).catch(Raven.captureException.bind(Raven));
  };
  const handleConfirmRetakePracticalExercise = () => {
    setDisplayRetakeModal(false);
    UsageTracker.track('contentInteraction', {
      action: 'retry-practical-exercise',
      contentId,
      contentType: 'practical-exercise',
      trackId,
      lessonId
    });
    handleOnRetryPracticalExercise(Number(contentId));
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [displayRetakeModal && /*#__PURE__*/_jsx(RetakePracticalExerciseModal, {
      onConfirm: handleConfirmRetakePracticalExercise,
      onReject: handleRejectRetakePracticalExercise
    }), /*#__PURE__*/_jsx(Tooltip, {
      disabled: !(requiredProduct || requiredAccess),
      headingText: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.header`
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.header`
      }),
      title: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.description`
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.description`
      }),
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "practical-exercise-retry-button",
        disabled: !!requiredProduct || !!requiredAccess,
        onClick: handleClickRetakeExercise,
        use: use,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.retake"
        })
      })
    })]
  });
};
export default PracticalExerciseRetryButtonContainer;